import styled from 'styled-components';

import {breakpoint} from 'theme';

export const Grid = styled.div<{columns: string; mb?: string}>`
    display: grid;
    grid-template-columns: ${(p) => p.columns};
    grid-auto-rows: auto;
    gap: 10px;
    width: 100%;
    height: 100%;
    margin-bottom: ${(p) => p.mb ?? '0px'};
    @media (max-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr;
    }
`;

export const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: stretch;
    gap: 16px;
    margin-top: 16px;
`;
